/** Constantes compartilhadas do módulo ARCA Formulários / Editais */

export const TIPOS_CAMPO = [
  { tipo: 'SECAO', label: 'Tópico / Seção' },
  { tipo: 'SELECAO_UNICA', label: 'Critério (C/NC/NA)' },
  { tipo: 'TEXTO', label: 'Texto curto' },
  { tipo: 'TEXTO_LONGO', label: 'Texto longo' },
  { tipo: 'NUMERO', label: 'Número' },
  { tipo: 'DATA', label: 'Data' },
  { tipo: 'HORA', label: 'Hora' },
  { tipo: 'BOOLEANO', label: 'Sim/Não' },
  { tipo: 'SELECAO_MULTIPLA', label: 'Seleção múltipla' },
  { tipo: 'ARQUIVO', label: 'Anexo / Foto' },
  { tipo: 'ASSINATURA', label: 'Assinatura' },
  { tipo: 'TABELA', label: 'Tabela' }
];

export const OPCOES_CONFORMIDADE = ['Conforme', 'Não conforme', 'N/A'];

/** C = 1 | NC = 0 | NA = ignora */
export const SCORE_MAP = {
  Conforme: 1,
  'Não conforme': 0,
  'N/A': null,
  C: 1,
  NC: 0,
  NA: null
};

export function pontosDaResposta(valor) {
  if (valor == null || valor === '') return null;
  if (Object.prototype.hasOwnProperty.call(SCORE_MAP, valor)) return SCORE_MAP[valor];
  const u = String(valor)
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  if (u === 'NA' || u === 'N/A' || u.includes('NAO APLIC')) return null;
  if (u === 'NC' || u.includes('NAO CONFORME')) return 0;
  if (u === 'C' || (u.includes('CONFORME') && !u.includes('NAO'))) return 1;
  return null;
}

/** % conformidade = C / (C+NC) * 100; NA fora do cálculo. */
export function calcPercentualConformidade(respostas, campos) {
  let conformes = 0;
  let naoConformes = 0;
  let naoAplicaveis = 0;
  for (const campo of campos || []) {
    if (!campo || campo.tipo === 'SECAO') continue;
    const r = respostas?.[campo.chave];
    if (r == null || r === '') continue;
    const pts = pontosDaResposta(r);
    if (pts === null && (r === 'N/A' || String(r).toUpperCase() === 'NA' || String(r).includes('N/A'))) {
      naoAplicaveis += 1;
    } else if (pts === 1) conformes += 1;
    else if (pts === 0) naoConformes += 1;
    else if (r === 'N/A' || String(r).toUpperCase().includes('NÃO APLIC') || String(r).toUpperCase().includes('NAO APLIC')) {
      naoAplicaveis += 1;
    }
  }
  const avaliados = conformes + naoConformes;
  const percentual = avaliados > 0 ? Math.round((conformes / avaliados) * 1000) / 10 : null;
  return { conformes, naoConformes, naoAplicaveis, avaliados, percentual };
}

export const TIPOS_SERVICO = [
  { value: 'COZINHA', label: 'Cozinha / Alimentação' },
  { value: 'LIMPEZA', label: 'Limpeza' },
  { value: 'MANUTENCAO', label: 'Manutenção' },
  { value: 'LAVANDERIA', label: 'Lavanderia' },
  { value: 'SEGURANCA', label: 'Segurança' },
  { value: 'TRANSPORTE', label: 'Transporte' },
  { value: 'VISITA_TECNICA', label: 'Visita técnica' },
  { value: 'OUTRO', label: 'Outro' }
];

export const VINCULO_TIPOS = [
  { value: 'LIVRE', label: 'Livre' },
  { value: 'CONTRATO', label: 'Contrato SGC' },
  { value: 'PROPOSTA', label: 'Proposta de edital' },
  { value: 'CADASTRO_VISITA', label: 'Cadastro + visita técnica' },
  { value: 'EDITAL', label: 'Edital' }
];

export const KANBAN_COLUNAS = [
  { status: 'BACKLOG', titulo: 'Backlog' },
  { status: 'ABERTO', titulo: 'Aberto' },
  { status: 'EM_ELABORACAO', titulo: 'Em Elaboração' },
  { status: 'EM_REVISAO', titulo: 'Em Revisão' },
  { status: 'EM_COTACAO', titulo: 'Em Cotação' },
  { status: 'PUBLICADO', titulo: 'Publicado' },
  { status: 'EM_ANDAMENTO', titulo: 'Em Andamento' },
  { status: 'PRAZO_FINALIZADO', titulo: 'Prazo Finalizado' },
  { status: 'HOMOLOGADO', titulo: 'Homologado' },
  { status: 'CANCELADO', titulo: 'Cancelado' }
];

export const STATUS_KANBAN = KANBAN_COLUNAS.map((c) => ({
  value: c.status,
  label: c.titulo
}));

export const PRIORIDADES = [
  { value: 'BAIXA', label: 'Baixa' },
  { value: 'MEDIA', label: 'Média' },
  { value: 'ALTA', label: 'Alta' },
  { value: 'URGENTE', label: 'Urgente' }
];

export const STATUS_TEMPLATE_COLOR = {
  RASCUNHO: 'default',
  PUBLICADO: 'success',
  ARQUIVADO: 'warning'
};
